
export default {
  // Navigation
  "home": "Accueil",
  "airports": "Aéroports",
  "inventory": "Inventaire",
  "profile": "Profil",
  "settings": "Paramètres",
  "admin": "Administration",
  "search": "Rechercher",
  "notifications": "Notifications",
  "sign_out": "Déconnexion",
  "sign_in": "Connexion",
  "sign_up": "S'inscrire",
  "add_review": "Ajouter un avis",
  "camera_inventory": "Inventaire d'appareils photo",
  "film_inventory": "Inventaire de films",
  "lens_inventory": "Inventaire d'objectifs",
  "dark_mode": "Mode sombre",
  "light_mode": "Mode clair",
  "users": "Utilisateurs",
  "feedback": "Retours",
  "reports": "Rapports",
  "user_management": "Gestion des utilisateurs",
  "airport_management": "Gestion des aéroports",
  "security_events": "Événements de sécurité",
  "back": "Retour",
  "loading": "Chargement...",
  "search_airports": "Rechercher des aéroports",
  "search_placeholder": "Rechercher des aéroports, des avis...",
  "develop": "Développer",
  // "light_meter": "Photomètre", // Commented out to hide from navigation
};
